import lmsAPI from "./lmsAPI";

class GeocodeService {
  async create(address) {
    const res = await lmsAPI.post(`/geocode`, { address });
    return res.data;
  }
}

export default new GeocodeService();
